import axios from 'axios';
import { getToken } from '@/utils/auth';
import store from '@/store';
let cavcURL = config.cvac + 'cvac';
// 添加请求拦截器
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params, options) {
  let setOptions = Object.assign(options || {}, {
    headers: {
      token_type: 'guest',
      token: getToken() || store.getters.liveToken,
    },
  });

  return new Promise((resolve, reject) => {
    axios
      .get(cavcURL + url + params, setOptions)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

export function getJson(url, params, responseType) {
  let paramsInfo = {
    params,
    headers: {
      token_type: 'guest',
      token: getToken() || store.getters.liveToken,
    },
  };
  paramsInfo = Object.assign(paramsInfo, responseType);
  return new Promise((resolve, reject) => {
    axios
      .get(cavcURL + url, paramsInfo)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * 返回值如下：
 */
export function post(url, params, options) {
  // console.log(store.state);
  let setOptions = Object.assign(options || {}, {
    headers: {
      token_type: 'sid',
      token: store.getters.sid,
    },
  });
  let postUrl = `${cavcURL}${url}`;
  console.log('posturl', postUrl);
  return new Promise((resolve, reject) => {
    axios
      .post(postUrl, params, setOptions)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        if (err.status == '201') {
          resolve(err.data);
        } else {
          reject(err.data);
          console.log('err post error', err);
        }
      });
  });
}

/**
 * put方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * 返回值如下：
 */
export function put(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .put(cavcURL + url, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * 返回值如下：
 */
export function storePost(url, params, options) {
  // console.log(storeURl);
  let setOptions = Object.assign(options || {}, {
    headers: {
      token_type: 'guest',
      token: getToken() || store.getters.liveToken,
      'Content-Type': 'multipart/form-data;charset=UTF-8',
    },
  });
  return new Promise((resolve, reject) => {
    axios
      .post(cavcURL + url, params, setOptions)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
